import { render, staticRenderFns } from "./AdminDepositCreateForm.vue?vue&type=template&id=c47b4654&"
import script from "./AdminDepositCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports